import React, { useState } from "react";
import { useForm } from "react-hook-form";
import PageName from "../../components/PageName";
import Card from "../../components/Base/Card"
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import LoadingSpinner from "../../components/LoadingSpinner";
import {CORGRequest} from "../../redux/selfService/selfServiceSlice";

const lastYearToday = new Date();
lastYearToday.setFullYear(lastYearToday.getFullYear() - 1);

const CorgRequest = () => {
  const dispatch = useAppDispatch();
  const { isLoading } = useAppSelector((state) => state?.selfService);


  const { handleSubmit} = useForm();

  const onSubmit = async (inputted: any) => {
      dispatch(CORGRequest({}));
  };


  return (
    <div className="statement-page">
      <PageName pageName={"Certificate of Registration"} />
      <div className="statement">
        <Card className="statement-page-card">
          <div className="h1 text-grayscaleBody">Certificate of Registration.</div>
          <div className="flex justify-end mt-4">
            <button
              type="submit"
              style={{ backgroundColor: "#305F32" }}
              disabled={isLoading}
              className="btn btn-primary btn-b ml-4"
              onClick={handleSubmit(onSubmit)}
            >
                {
                    isLoading ?
                        <LoadingSpinner /> : "Request Certificate of Registration"
                }
            </button>
          </div>
        </Card>
      </div>
    </div>
  );
};
export default CorgRequest;
